import { render } from "./AddToWishList.vue?vue&type=template&id=d5e57da2&scoped=true"
import script from "./AddToWishList.vue?vue&type=script&lang=js"
export * from "./AddToWishList.vue?vue&type=script&lang=js"

import "./AddToWishList.vue?vue&type=style&index=0&id=d5e57da2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5e57da2"]])

export default __exports__